import "./Projects.css";
import {
  MapPin,
  ArrowLeft,
  ChevronLeft,
  ChevronRight
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useRef } from "react";
import { Helmet } from "react-helmet-async";
import { projects } from "../../pages/projects";

const Projects = ({ limit }) => {
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  const isSlider = Boolean(limit);
  const visibleProjects = isSlider ? projects.slice(0, limit) : projects;

  const slide = (direction) => {
    const container = sliderRef.current;
    if (!container) return;

    const scrollAmount = container.offsetWidth * 0.9;
    container.scrollLeft += direction * scrollAmount;
  };

  return (
    <>
      {/* ✅ SEO START */}
      <Helmet>
        <title>
          {isSlider
            ? "Latest Real Estate Projects in Bangalore | Jayaram Group"
            : "All Real Estate Projects in Bangalore | Jayaram Group"}
        </title>

        <meta
          name="description"
          content="Explore premium residential and commercial projects in Hebbal, Whitefield, Sarjapur and across Bangalore by Jayaram Group."
        />

        <meta
          name="keywords"
          content="Bangalore real estate, apartments in Hebbal, villas in Whitefield, Sarjapur plots, Jayaram Group projects"
        />

        <meta property="og:title" content="Jayaram Group Projects" />
        <meta
          property="og:description"
          content="Discover premium residential and commercial properties in Bangalore."
        />
        <meta property="og:type" content="website" />

        <link rel="canonical" href="https://yourdomain.com/projects" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "RealEstateAgent",
            name: "Jayaram Group",
            url: "https://yourdomain.com",
            areaServed: "Bangalore",
            makesOffer: visibleProjects.map((item) => ({
              "@type": "Offer",
              itemOffered: {
                "@type": "Residence",
                name: item.title,
                address: item.location
              }
            }))
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      <section className="latest-projects">
        <div className="projects-header">
          <div>
            <h2>{isSlider ? "Latest Projects" : "All Projects"}</h2>
            <p>When extraordinary landmarks meet impeccable service</p>
          </div>

          {isSlider ? (
            <Link to="/projects" className="see-all">
              See All Projects →
            </Link>
          ) : (
            <button className="back-btn2" onClick={() => navigate("/")}>
              <ArrowLeft size={16} />
              Back to Home
            </button>
          )}
        </div>

        <div className="projects-slider-wrapper">
          <div
            ref={sliderRef}
            className={`projects-container ${isSlider ? "slider" : "grid"}`}
          >
            {visibleProjects.map((item) => (
              <div
                key={item.slug}
                className="project-card"
                onClick={() => navigate(`/projects/${item.slug}`)}
              >
                <div className="project-image">
                  <img
                    src={item.image}
                    alt={`${item.title} in ${item.location}`}
                    loading="lazy"
                  />
                    <span className="rera-badge-card">
    RERA Approved 
  </span>
                  <span className="image-tag1">{item.imageTag}</span>
                </div>

                <div className="project-content">
                  <h3>{item.title}</h3>

                  <div className="location">
                    <MapPin size={14} />
                    {item.location}
                  </div>

                  <span className={`status ${item.statusType}`}>
                    {item.status}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {isSlider && (
            <div className="slider-controls">
              <button onClick={() => slide(-1)}>
                <ChevronLeft size={22} />
              </button>
              <button onClick={() => slide(1)}>
                <ChevronRight size={22} />
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Projects;